import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';

export function LanguageToggle({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  const { i18n, t } = useTranslation('common');
  const isArabic = i18n.resolvedLanguage?.startsWith('ar') ?? false;
  const nextLanguage = isArabic ? 'en' : 'ar';

  return (
    <button
      type="button"
      className={cn('language-toggle focus-ring', compact && 'language-toggle--compact', className)}
      onClick={() => void i18n.changeLanguage(nextLanguage)}
      aria-label={isArabic ? t('language.switchToEnglish') : t('language.switchToArabic')}
    >
      <Languages size={16} aria-hidden="true" />
      <span>{isArabic ? t('language.english') : t('language.arabic')}</span>
    </button>
  );
}
